import { createFileRoute } from '@tanstack/react-router'
import Documentation from '@/features/api-settings/components/documentation'

export const Route = createFileRoute('/_authenticated/api-settings/doc')({
  component: Documentation,
})
